import {Component} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Taetigkeitsart} from '@nachdigal';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {FormBuilder} from '@angular/forms';

const minLength = 1;
const maxLength = 200;

@Component({
  selector: 'common-ui-taetigkeitsart',
  templateUrl: './taetigkeitsart.component.html'
})
export class TaetigkeitsartComponent extends FormBaseComponent<Taetigkeitsart> {
  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      taetigkeitsart: [this.data.taetigkeitsart, [
        this.validatorService.required(),
        this.validatorService.minLength(minLength),
        this.validatorService.maxLength(maxLength)
      ]],
      vermoegendsverwaltend: [this.data.vermoegendsverwaltend]
    });
  }
}
